import m from "../../../../geodata/es2015/region/usa/miHigh";
window.am4geodata_region_usa_miHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/miHigh.js
// module id = null
// module chunks = 